<template>
    <div class="gz-date-input">
        <Datepicker 
            class="gz-date-input__item"
            calendar-class="gz-date-input__item_inner"
            type="date"
            value-zone="local"
            v-model="dateFrom"
            :language="ru"
            @input="from"
            placeholder="c"
        />
        <Datepicker 
            class="gz-date-input__item"
            type="date"
            value-zone="local"
            v-model="dateTo"
            :language="ru"
            @input="to"
            placeholder="по"
        />
    </div>
</template>

<script>
import {ru} from 'vuejs-datepicker/dist/locale'

export default {
    name: 'DateRangeInput',

    props: {
        value: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            dateFrom: this.value ? this.value : '',
            dateTo: this.value ? this.value : '',
            ru: ru
        }
    },
    methods: {
        from() {
            this.$emit('dateFromValue', this.dateFrom)
        },
        to() {
            this.$emit('dateToValue', this.dateTo)
        }
    },
    watch: {
        dateFrom: function(val) {
            if (val && this.dateTo === '') this.dateTo = this.dateFrom
        },
        dateTo: function(val) {
            if (val && this.dateFrom === '') this.dateFrom = this.dateTo
        }
    }
}
</script>